import { axios } from '@/plugins/axios';
import { InfosDelegation } from '@/components/MesParametres/ParametresVaccination/ParametresDelegation/types';

export function closeManualVaccination(postInjectionCloseRequest: {
	numeroBon: string,
	close: boolean,
	psDelegation: InfosDelegation | undefined}) {
	return axios.post('/vaccination-covid-api/injection/close', postInjectionCloseRequest);
}
